
import { Injectable } from "@angular/core";
import { ComponentStore } from '@ngrx/component-store';
import { combineLatest } from "rxjs";
import {  map } from "rxjs/operators";
import { AdvancedFiltersFormStore } from "../advanced-filters-form/advanced-filters-form.store";
import { FiltersFormStore } from "../filter-forms/filter-forms.store";
import { StatusMockStore } from "src/app/shared/store-mocks/status.store";

type State = {}

const initialState: State = {}

@Injectable()
export class AdvancedFiltersFormWhatsappStatusStore extends ComponentStore<State>{

    constructor(
        private filtersFormStore: FiltersFormStore,
        private advancedFiltersFormStore: AdvancedFiltersFormStore,
        private messageLogsStatusMockStore: StatusMockStore,
    ){
        super(initialState)
    }

    //selectors
    readonly statusValue$ = combineLatest([
        this.filtersFormStore.status$,
        this.advancedFiltersFormStore.whatsappStatusVisibility$
    ]).pipe(
        map(([value, visibility]) => visibility ? value : ''),
    )

    readonly entities$ = this.select(
        this.messageLogsStatusMockStore.whatsappStatuses$,
        (statuses) => statuses
    )
}